import { Wrench } from "lucide-react";

export function Brand({ subtitle = "Handyman Quote", size = "md" }) {
  const big = size === "lg";
  return (
    <div className="flex flex-col items-center text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary shadow-md">
        <Wrench className="h-8 w-8 text-secondary" strokeWidth={2.2} />
      </div>
      <h1 className={`font-display font-extrabold tracking-tight text-primary mt-4 ${big ? "text-4xl sm:text-5xl" : "text-2xl"}`}>
        MR SHU
      </h1>
      <p className="text-xs tracking-[0.25em] uppercase font-semibold text-muted-foreground mt-1">
        {subtitle} · Christchurch NZ
      </p>
    </div>
  );
}
